import {
  AIFeatureKind,
  AIFeaturePresetType,
  AIFeatureType,
  AIResult,
  AIResultStatus,
  AITargetType,
  ComplexAIResultType,
  RoomSession,
} from '@zocks-communications/client-sdk-js'
import { AiFeaturePreset } from '../../../../models/AiFeaturePreset'

export const demoSession = {
  id: 'sample-meeting',
  roomId: 'demo-room',
  isActive: false,
  startedAt: '2023-11-13T08:00:00.000000Z',
  finishedAt: '2023-11-13T08:11:33.280000Z',
  users: [
    {
      email: 'demo-email-1',
      phoneNumber: '',
      roles: [],
      firstName: 'Mark',
      lastName: 'Gilbert',
      name: 'Mark Gilbert',
      integrations: [],
      id: 'user-id-1',
      username: 'Mark Gilbert',
      type: '',
      status: '',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      email: 'demo-email-2',
      phoneNumber: '',
      roles: [],
      firstName: 'Andrew',
      lastName: 'Schroeder',
      name: 'Andrew Schroeder',
      integrations: [],
      id: 'user-id-2',
      username: 'Andrew Schroeder',
      type: '',
      status: '',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ],
  kind: 'external',
  metadata: '{"source": "import", "external": {"title": "Sample Meeting"}}',
} as RoomSession

export const aiFeaturePresets: AiFeaturePreset[] = [
  {
    id: 'cvlbyfpvcpn8lm79',
    accountId: undefined,
    name: 'Scheduled meetings',
    type: AIFeaturePresetType.PRESET,
    description: 'Future meetings scheduled during the meeting.',
    assetUrl: 'https://zocks-video-test.s3.eu-central-1.amazonaws.com/static/img/preset_basic_general.svg',
    isActive: true,
    tags: ['General'],
    inputParametersSchema: undefined,
    createdAt: '2023-11-13T12:03:53.448807Z',
    updatedAt: '2023-11-13T12:03:53.448807Z',
    installed: true,
    aiResultTypesSchema: {
      properties: {
        scheduledMeetings: {
          type: 'map',
          parsers: [
            {
              type: 'date',
              jsonPath: '$.result.result.*',
            },
          ],
          description: 'Future meetings scheduled during the meeting.',
        },
      },
    },
    aiFeature: {
      type: 'structuredSummary',
      generalConfig: {
        lifecycle: {
          realtime: false,
          fullContext: true,
        },
        userLevel: false,
        saveContext: true,
        retranscribe: false,
        multiUserInput: true,
      },
      metadata: '{"actionType": "copy", "onDemand": false, "order": 10}',
    },
    integrationInfos: [],
  },
]

export const aiFeaturesDemoData = [
  {
    id: '0itw6ze3v936m58g',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Detailed Financial Discussion',
    config: {
      resultType: 'string',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        professional_i_d: '98rhc42q33x2vqjl',
      },
    },
    dependencyId: null,
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: '44zbzir4phqu6y3w',
      type: AIFeaturePresetType.PRESET,
      name: 'Detailed Financial Discussion',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-11-15T10:18:29.023809Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 6}',
    updatedAt: '2023-11-15T10:18:29.023809Z',
    integrationInfos: [],
  },

  {
    id: '2bm9sn6ddokim00y',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: "Client's Financial Concerns",
    config: {
      resultType: 'list',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        '98rhc42q33x2vqjl': 'Financial Advisor',
      },
    },
    dependencyId: null,
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: 'dshudbybhopw2w7h',
      type: AIFeaturePresetType.PRESET,
      name: "Client's Financial Concerns",
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-11-15T10:07:28.865917Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 8}',
    updatedAt: '2023-11-15T10:07:28.865917Z',
    integrationInfos: [],
  },
  {
    id: '48u4gzlybnzaaa9k',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Financial Summary',
    config: {
      resultType: 'string',
      answerRoles: [],
      useParticipantNames: false,
      useParticipantRoles: false,
      participantRoleMapping: {},
    },
    dependencyId: 'aun6cg0ixychtssc',
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: '2tspyef3f59unqyl',
      type: AIFeaturePresetType.PRESET,
      name: 'Financial Summary',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-11-13T12:46:42.871861Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 7}',
    updatedAt: '2023-11-13T12:46:42.871861Z',
    integrationInfos: [],
  },
  {
    id: '2ai47ex5u3dsbtgv',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Financial Facts',
    config: {
      resultType: 'list',
      answerRoles: [],
      useParticipantNames: false,
      useParticipantRoles: false,
      participantRoleMapping: {},
    },
    dependencyId: '4hj5oxgwjjz98biv',
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: '0ne2r0wh5md57pcb',
      type: AIFeaturePresetType.PRESET,
      name: 'Financial Facts',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-30T15:29:00.855726Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 4}',
    updatedAt: '2023-11-13T14:10:48.884610Z',
    integrationInfos: [],
  },
  {
    id: 'em9yedd9o8gp8pc5',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Financial Facts by Topic',
    config: {
      resultType: 'map',
      answerRoles: [],
      useParticipantNames: false,
      useParticipantRoles: false,
      participantRoleMapping: {},
    },
    dependencyId: '161t0hl2fmfzcne6',
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: 'ast31baamoedbzsr',
      type: AIFeaturePresetType.PRESET,
      name: 'Financial Facts by Topic',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-25T16:20:30.676529Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 5}',
    updatedAt: '2023-11-13T14:10:42.130480Z',
    integrationInfos: [],
  },
  {
    id: '8uh43m5ase2hkcv4',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Conversation Timeline',
    config: {
      resultType: 'string',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        professional_i_d: '98rhc42q33x2vqjl',
      },
    },
    dependencyId: null,
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: '1yeurmenhtv0mxsx',
      type: AIFeaturePresetType.PRESET,
      name: 'Conversation Timeline',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-25T11:49:42.689057Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 5}',
    updatedAt: '2023-10-25T11:49:42.689057Z',
    integrationInfos: [],
  },
  {
    id: '51db1g7rl99evoq8',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Meeting Purpose',
    config: {
      resultType: 'string',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        professional_i_d: '98rhc42q33x2vqjl',
      },
    },
    dependencyId: null,
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: 'cinohoyphbq9k6ze',
      type: AIFeaturePresetType.PRESET,
      name: 'Meeting Purpose',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-25T11:48:13.766972Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy" ,"onDemand": true, "order": 1}',
    updatedAt: '2023-10-25T11:48:13.766972Z',
    integrationInfos: [],
  },
  {
    id: 'bg3cwgkw8gfr04t5',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    name: 'Client and Advisor Follow Ups',
    config: {
      resultType: 'map',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        professional_id: '98rhc42q33x2vqjl',
      },
    },
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: 'cqkkd1xbz240b6b7',
      type: AIFeaturePresetType.PRESET,
      name: 'Client and Advisor Follow Ups',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-25T11:48:06.481710Z',
    inputParameters: undefined,
    metadata: '{"actionType": "copy", "onDemand": true, "order": 3}',
    updatedAt: '2023-11-13T14:10:36.652277Z',
    integrationInfos: [],
  },
  {
    id: 'dy1zs12a0fym1m70',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    restricted: false,
    name: 'Client Follow Up Email',
    config: {
      resultType: 'string',
      answerRoles: [],
      useParticipantNames: true,
      useParticipantRoles: true,
      participantRoleMapping: {
        professional_i_d: '98rhc42q33x2vqjl',
      },
    },
    dependencyId: null,
    dependencyResultMapping: null,
    kind: AIFeatureKind.PROVIDED,
    preset: {
      id: '20zly5w1yapdyipb',
      type: AIFeaturePresetType.PRESET,
      name: 'Client Follow Up Email',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    createdAt: '2023-10-25T11:47:50.401469Z',
    inputParameters: undefined,
    metadata: '{"actionType": "email" ,"onDemand": true, "order": 4 }',
    updatedAt: '2023-11-13T14:10:30.435407Z',
    integrationInfos: [],
  },
  {
    id: '9go9ntwfkiz2c0k1',
    isActive: true,
    isGlobal: true,
    type: AIFeatureType.STRUCTURED_SUMMARY,
    generalConfig: {
      multiUserInput: true,
      userLevel: false,
      retranscribe: false,
      lifecycle: {
        realtime: false,
        fullContext: true,
      },
      saveContext: false,
    },
    executionTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    roomIds: [],
    kind: AIFeatureKind.PROVIDED,
    dependencyId: null,
    dependencyResultMapping: null,
    restricted: false,
    updatedAt: '2023-11-20T16:22:43.076639Z',
    metadata: '{"actionType": "copy", "onDemand": false, "order": 10}',
    name: 'Future Meetings',
    inputParameters: undefined,
    config: {
      resultType: 'map',
      answerRoles: [],
      useParticipantNames: false,
      useParticipantRoles: false,
      participantRoleMapping: {},
    },
    createdAt: '2023-11-20T16:22:43.076639Z',
    preset: {
      id: 'cvlbyfpvcpn8lm79',
      type: AIFeaturePresetType.PRESET,
      name: 'Future Meetings',
    },
    resultTargets: [
      {
        targetType: AITargetType.ALL,
      },
    ],
    integrationInfos: [],
  },
]

export const aiResultResponse: AIResult[] = [
  {
    id: '4302oeyl1pgsf13i',
    aiFeatureId: '48u4gzlybnzaaa9k',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-17T10:33:53.452419Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result:
        "Mark and Carrie, parents to Zach and Tim, reside in San Francisco. Mark is employed in the tech industry and also runs a small business, while Carrie operates a personal training business. Their combined monthly income from these ventures ranges from $6,000 to $13,000. Additionally, they earn an unspecified amount from a rental property. Mark, currently 46, plans to retire at 55. \n\nTheir financial portfolio includes a Canadian RSP valued at approximately $420,000 CAD, a U.S. 401k worth around $750,000, and $180,000 in equities held in a Schwab account. They also own a lakeside plot of land purchased for $40,000, with plans to construct a cabin estimated to cost $200,000. Various financing options for this project are under consideration, including 401k loans, a building loan, or leveraging home equity from their primary residence. \n\nFor their sons' education, they have set up two 529 accounts, each containing about $80,000. They intend to contribute $20,000 annually towards college tuition. Zach, their eldest, has just begun college with an annual tuition fee of $24,000. \n\nDespite having a decade-old will, Mark and Carrie have not undertaken any estate planning. They have committed to providing their 2022 tax return to the financial advisor within the next five days. The next meeting with them is yet to be scheduled.",
    },
    scores: [],
  },
  {
    id: '3gxyf6trcfd9zmlf',
    aiFeatureId: '2bm9sn6ddokim00y',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-15T17:15:30.093989Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result: [
        'Mark is concerned about the financial planning for his vacation house. He is unsure whether to take loans from his 401k, get a building loan, or take home equity on his primary residence. He is seeking guidance on the best way to manage this from a cash flow point of view.',
        'Mark is also worried about the variable income from his side business and how to plan around it. He is also unsure if he is making smart decisions from a tax point of view.',
        'Mark has expressed a need for estate planning. He has a will from ten years ago but nothing else, and he believes it would be a good thing to get set up.',
      ],
    },
    scores: [],
  },
  {
    id: 'axk8bl3vg3p87due',
    aiFeatureId: '0itw6ze3v936m58g',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-15T17:15:00.937151Z',
    result: {
      type: ComplexAIResultType.SEGMENTED,
      segmentResults: [
        {
          results: [
            {
              type: AIFeatureType.STRUCTURED_SUMMARY,
              result:
                "Main Topics: Retirement Planning, Income and Expenses, Investment Portfolio, Estate Planning, College Tuition Planning, Vacation Home Financing.\n\nMark and his wife Carrie live in San Francisco with their two sons, one in high school and the other starting college. Mark works in tech and has a side business, earning around $150,000 annually from his main job and between $2,000 to $7,000 from his side business. He also receives an annual bonus of up to $10,000. Carrie started a personal training business last year, earning between $4,000 to $6,000 monthly. They own a property in Tahoe and are considering building a vacation home on a piece of land they bought for $40,000. The estimated cost of building the cabin is $200,000. They are unsure about the best financing option for this project.\n\nMark and Carrie have a Canadian RSP worth about $420,000 CAD, a 401k in the US worth about $750,000, and separate investments in equities worth about $180,000. They also have 529 accounts for their sons, each with about $80,000, and plan to contribute $20,000 annually towards their sons' college tuition. Their older son's tuition is $24,000 annually at a state school in California.\n\nMark's retirement goal is to have the choice to stop working by the age of 55. He is currently 46. They have not set up any estate planning beyond a will from ten years ago. They will send their 2022 tax return to the financial advisor within the next five days for further financial planning.",
            },
          ],
          metadata: {
            segmentIdx: 0,
            startTime: 1699862405.3599997,
            endTime: 1699863088.375,
            topic: null,
          },
        },
      ],
    },
    scores: [],
  },
  {
    id: '4ne2ifp2kk64v1nc',
    aiFeatureId: 'bg3cwgkw8gfr04t5',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-15T15:28:48.465692Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result: {
        "Client's Task": [
          'Ensure to send the 2022 tax return to Andrew within the next five days.',
          'Consider the options for financing the vacation house construction, including loans from 401k, building loan, or home equity on primary residence.',
          'Revisit the will that was created ten years ago and consider setting up an estate plan.',
          'Keep track of the variable income from the side business, which ranges from $2,000 to $7,000 monthly.',
          'Monitor the 529 accounts for both children, each containing about $80,000, to assist with their college tuition.',
        ],
        "Advisor's Task": [
          "Analyze Mark's financial situation using the provided income specifics and the 2022 tax return.",
          'Provide guidance on the best way to finance the vacation house construction, considering the high interest rates.',
          'Assist in setting up an estate plan for Mark and his wife.',
          'Develop a retirement plan for Mark, aiming for the possibility of retirement by the age of 55.',
          "Create a plan to manage the college tuition expenditures for Mark's sons, considering the $20,000 annual assistance from their 529 accounts.",
        ],
      },
    },

    scores: [],
  },
  {
    id: 'e33xk5cnb5vqv1kt',
    aiFeatureId: 'dy1zs12a0fym1m70',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.450276Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result:
        "Subject: Action Items and Next Steps from Our Financial Planning Meeting\n\nDear Mark,\n\nI hope this email finds you well. It was a pleasure meeting with you and discussing your financial goals. I appreciate your openness and the detailed information you provided. Based on our conversation, I have outlined the following action items for us to work on:\n\n1. Retirement Planning: You mentioned that you would like to have the option to retire by the age of 55. Given your current age of 46, we have approximately nine years to plan for this. I will be working on a detailed retirement plan considering your current assets, which include a Canadian RSP worth about 420,000 Canadian dollars, a 401k in the US worth about 750,000 dollars, and separate investments in equities worth about 180,000 dollars in a Schwab account. \n\n2. Vacation Home Financing: You mentioned your plans to build a vacation home on a piece of land you bought for 40,000 dollars. The estimated cost of building the cabin is around 200,000 dollars. I will explore various financing options for this project, including loans from your 401k, building loans, or home equity on your primary residence. I will provide a detailed comparison of these options, considering the current high-interest rates.\n\n3. Estate Planning: We discussed the importance of updating your estate plan. Your current will is ten years old, and it would be beneficial to review and update it. I will introduce you to an estate lawyer who can guide you through this process.\n\n4. College Tuition Planning: Your sons' education is a priority, and you have 529 accounts for both of them, each with about 80,000 dollars. I will work on a plan to ensure these funds are utilized effectively to cover their tuition costs.\n\n5. Tax Planning: You expressed a desire to ensure you're making smart decisions from a tax perspective. Once I receive your 2020 tax return, I will review it and provide recommendations for potential tax savings.\n\n6. Business Planning: Your wife's personal training business is generating income between 4,000 to 6,000 dollars a month. I will look into whether setting up a 401k or other retirement savings plan for her business would be beneficial.\n\nFor your part, please send me your 2020 tax return within the next five days as discussed. This will allow me to have a clearer view of your financial situation and make more accurate recommendations.\n\nOnce I have completed these tasks, I propose we schedule another meeting to discuss my findings and the next steps. I will reach out to you in the coming weeks to set up this meeting.\n\nIn the meantime, I hope you and Carrie enjoy your time skiing in Tahoe. It's great to hear that you're keeping active and making the most of your time there.\n\nBest Regards,\n\n[Your Name]",
    },

    scores: [],
  },
  {
    id: '79gps7q7c30u0b5i',
    aiFeatureId: '51db1g7rl99evoq8',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.449817Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result:
        "The purpose of this meeting was to discuss Mark's current financial situation, his short-term and long-term financial goals, and to start planning for his retirement. We also discussed his income, assets, and potential strategies for financing a vacation home. Additionally, we touched on the need for estate planning and setting up a retirement plan for his wife's business.",
    },

    scores: [],
  },
  {
    id: '6cqilh0c7qon4mv5',
    aiFeatureId: '8uh43m5ase2hkcv4',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.449008Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result:
        "1. Introduction and personal background - 20%\n2. Current financial situation and goals - 25%\n3. Income specifics - 10%\n4. Retirement goals and current assets - 20%\n5. Vacation house plans - 15%\n6. Wife's income and business - 5%\n7. Estate planning - 2.5%\n8. Children's education expenses - 2.5%",
    },

    scores: [],
  },
  {
    id: 'cjcvvir8u3iyj0l3',
    aiFeatureId: 'em9yedd9o8gp8pc5',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.448807Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result: {
        'Tax Planning': ['No specific discussion points mentioned'],
        'Estate Planning': ['They have a will from ten years ago but no other estate planning'],
        'Profile & Goals': [
          'Mark and his wife Carrie live in San Francisco',
          'They have two kids, Zach and Tim, one in high school and one starting college',
          'They own a place in Tahoe and are avid skiers',
          'Mark works in tech and has started a small business on the side',
          'Carrie started a personal training business last year',
          'Mark would like to have the choice to stop working by the age of 55',
          'He is currently 46 years old',
        ],
        'Education Planning': [
          'They have a 529 account for each of their sons with about $80,000 in each',
          'They plan to help their sons with $20,000 a year for college tuition',
          'Tuition for their son Zach, who is at a state school in California, is $24,000 a year',
        ],
        'Equity Compensation': ['No specific discussion points mentioned'],
        'Investment Management': [
          'They have a Canadian RSP worth about $420,000',
          'A 401k in the US worth about $750,000',
          'Separate investments in equities worth about $180,000 in a Schwab account',
        ],
        'Retirement Forecasting': ['Mark would like to have the choice to stop working by the age of 55', 'He is currently 46 years old'],
        'Cash Flow & Debt Management': [
          "Mark's main job brings in about $150,000 a year, with an annual bonus of up to $10,000",
          'His side business brings in between $2,000 to $7,000 a month',
          'Carrie makes between $4,000 to $6,000 a month from her personal training business',
        ],
        'Insurance & Risk Management': ['No specific discussion points mentioned'],
      },
    },

    scores: [],
  },
  {
    id: '70e8jgx0co1cra49',
    aiFeatureId: '2ai47ex5u3dsbtgv',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.448590Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result: [
        'Mark and Carrie live in San Francisco and own a place in Tahoe.',
        'They have two kids, Zach and Tim, one in high school and one starting college.',
        'Mark works in tech and earns $150,000 a year with an annual bonus of up to $10,000.',
        'Mark has a side business that earns between $2,000 to $7,000 a month.',
        'Carrie started a personal training business last year earning between $4,000 to $6,000 a month.',
        "They are considering setting up a 401k for Carrie's business.",
        'They have a Canadian RSP worth about $420,000 Canadian dollars.',
        'They have a 401k in the US worth about $750,000.',
        'They have separate investments in equities worth about $180,000 in a Schwab account.',
        'They bought a piece of land by a lake for $40,000 and plan to build a cabin costing about $200,000.',
        'They have a will from ten years ago.',
        'They have a 529 account for each of their sons with about $80,000 in each.',
        'They plan to help their sons with $20,000 a year for college.',
        'Tuition for their son Zach at a state school in California is $24,000 a year.',
        'They are planning to send their tax return from 2022.',
        'Mark is 46 years old and aims to retire by 55.',
      ],
    },
    scores: [],
  },
  {
    id: 'dl9s64ay1zeko162',
    aiFeatureId: '3j5fqnct1yfcyc4o',
    roomId: '4a46yo8x2uc8tx9o',
    sessionId: 'at6eyd62169570bj',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-13T12:03:53.448229Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result:
        'Subject: Recap and Next Steps from Our Recent Financial Discussion\n\nDear Mark,\n\nI trust this email finds you well. I appreciate the time you took to meet with me and discuss your financial goals and concerns. \n\nDuring our meeting, we discussed your current financial situation, including your income from your main job and side business, which ranges from $150,000 to $234,000 annually. We also touched on your retirement goals, your current assets, and the potential construction of a vacation home. \n\nAs we move forward, I kindly ask you to review the action items we identified during the meeting. Please provide any supporting documents or information required promptly. Your active engagement and timely communication are essential for the successful implementation of your financial plan.\n\nShould you have any questions or require further assistance, please do not hesitate to reach out to me. I am here to support you.\n\nBest regards,\n\nAndrew\nFinancial Advisor\n[Company Name]\n[Contact Information]',
    },
    scores: [],
  },
  {
    id: '32qk52b3vzxtqr4z',
    aiFeatureId: '9go9ntwfkiz2c0k1',
    roomId: '82sew5yoalgjcx8d',
    sessionId: '6xgtlt6dobthfgbz',
    userId: null,
    status: AIResultStatus.FULL_CONTEXT,
    createdAt: '2023-11-14T11:37:59.949711Z',
    result: {
      type: AIFeatureType.STRUCTURED_SUMMARY,
      result: {
        'Final Plan Refinement Meeting': '2023-11-14T10:00:00Z',
        'Student Loan Analysis Meeting': '2023-12-16T13:30:00Z',
        'Progress Review and Plan Adjustment Meeting': '2023-12-31T10:00:00Z',
      },
    },
    originalResult: null,
    scores: [],
  },
]
